import QuantityProduct from './QuantityProduct'

class ElevatedPhotoProduct extends QuantityProduct {}

export default ElevatedPhotoProduct
